import { FileListItem } from '@views/documents/elements/FileList'

import type { DmsFolder } from '../types'

export const mapFolderToFileListItem = (folder: DmsFolder): FileListItem => {
  const { id, name, createdAt, createdBy } = folder

  return {
    id,
    type: 'folder',
    name,
    addedAt: createdAt,
    addedBy: createdBy?.name ?? '',
  }
}
